module.exports = __webpack_public_path__ + "assets/login-frontend/id_backside-37bb9906e3e84afd.png";